"use client";

import { useEffect } from "react";
import { useInstantSearch } from "react-instantsearch";

export function SearchStateRestorer() {
  const { setUiState } = useInstantSearch();

  useEffect(() => {
    // Check if we should restore state (e.g., when coming back from a profile page)
    const shouldRestore = sessionStorage.getItem("should_restore_search_state");

    if (shouldRestore) {
      const storedState = sessionStorage.getItem("meilisearch_state");

      if (storedState) {
        try {
          const {
            uiState: savedUiState,
            timestamp,
            metadata,
          } = JSON.parse(storedState);

          // Only restore if the state is less than 1 hour old
          const oneHour = 60 * 60 * 1000;
          if (Date.now() - timestamp < oneHour) {
            setUiState(savedUiState);

            // Restore scroll position after a short delay to allow content to load
            if (metadata?.scrollPosition) {
              setTimeout(() => {
                window.scrollTo({
                  top: metadata.scrollPosition,
                  behavior: "smooth",
                });
              }, 500);
            }
          }

          // Clean up
          sessionStorage.removeItem("should_restore_search_state");
        } catch (error) {
          console.warn("Failed to restore search state:", error);
        }
      }
    }
  }, [setUiState]);

  return null; // This component doesn't render anything
}
